import * as i0 from '@angular/core';
import { EventEmitter, Pipe, Directive, Input, Output, Component, ChangeDetectionStrategy, ViewEncapsulation, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
function PaginationControlsComponent_ul_3_li_1_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵlistener("keyup.enter", function PaginationControlsComponent_ul_3_li_1_a_1_Template_a_keyup_enter_0_listener() {
      i0.ɵɵrestoreView(_r2);
      i0.ɵɵnextContext(3);
      const p_r3 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(p_r3.previous());
    })("click", function PaginationControlsComponent_ul_3_li_1_a_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      i0.ɵɵnextContext(3);
      const p_r3 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(p_r3.previous());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.previousLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.screenReaderPageLabel);
  }
}
function PaginationControlsComponent_ul_3_li_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.previousLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.screenReaderPageLabel);
  }
}
function PaginationControlsComponent_ul_3_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 9);
    i0.ɵɵtemplate(1, PaginationControlsComponent_ul_3_li_1_a_1_Template, 4, 2, "a", 10)(2, PaginationControlsComponent_ul_3_li_1_span_2_Template, 4, 2, "span", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const p_r3 = i0.ɵɵreference(1);
    i0.ɵɵclassProp("disabled", p_r3.isFirstPage());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", 1 < p_r3.getCurrent());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", p_r3.isFirstPage());
  }
}
function PaginationControlsComponent_ul_3_li_4_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵlistener("keyup.enter", function PaginationControlsComponent_ul_3_li_4_a_1_Template_a_keyup_enter_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const page_r6 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵnextContext(2);
      const p_r3 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(p_r3.setCurrent(page_r6.value));
    })("click", function PaginationControlsComponent_ul_3_li_4_a_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const page_r6 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵnextContext(2);
      const p_r3 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(p_r3.setCurrent(page_r6.value));
    });
    i0.ɵɵelementStart(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const page_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r3.screenReaderPageLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(page_r6.label === "..." ? page_r6.label : i0.ɵɵpipeBind2(5, 2, page_r6.label, ""));
  }
}
function PaginationControlsComponent_ul_3_li_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 16)(2, "span", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "number");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const page_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r3.screenReaderCurrentLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(page_r6.label === "..." ? page_r6.label : i0.ɵɵpipeBind2(6, 2, page_r6.label, ""));
  }
}
function PaginationControlsComponent_ul_3_li_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, PaginationControlsComponent_ul_3_li_4_a_1_Template, 6, 5, "a", 10)(2, PaginationControlsComponent_ul_3_li_4_ng_container_2_Template, 7, 5, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r6 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const p_r3 = i0.ɵɵreference(1);
    i0.ɵɵclassProp("current", p_r3.getCurrent() === page_r6.value)("ellipsis", page_r6.label === "...");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", p_r3.getCurrent() !== page_r6.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", p_r3.getCurrent() === page_r6.value);
  }
}
function PaginationControlsComponent_ul_3_li_5_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵlistener("keyup.enter", function PaginationControlsComponent_ul_3_li_5_a_1_Template_a_keyup_enter_0_listener() {
      i0.ɵɵrestoreView(_r7);
      i0.ɵɵnextContext(3);
      const p_r3 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(p_r3.next());
    })("click", function PaginationControlsComponent_ul_3_li_5_a_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      i0.ɵɵnextContext(3);
      const p_r3 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(p_r3.next());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.nextLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.screenReaderPageLabel);
  }
}
function PaginationControlsComponent_ul_3_li_5_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.nextLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.screenReaderPageLabel);
  }
}
function PaginationControlsComponent_ul_3_li_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 17);
    i0.ɵɵtemplate(1, PaginationControlsComponent_ul_3_li_5_a_1_Template, 4, 2, "a", 10)(2, PaginationControlsComponent_ul_3_li_5_span_2_Template, 4, 2, "span", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const p_r3 = i0.ɵɵreference(1);
    i0.ɵɵclassProp("disabled", p_r3.isLastPage());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !p_r3.isLastPage());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", p_r3.isLastPage());
  }
}
function PaginationControlsComponent_ul_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 4);
    i0.ɵɵtemplate(1, PaginationControlsComponent_ul_3_li_1_Template, 3, 4, "li", 5);
    i0.ɵɵelementStart(2, "li", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PaginationControlsComponent_ul_3_li_4_Template, 3, 6, "li", 7)(5, PaginationControlsComponent_ul_3_li_5_Template, 3, 4, "li", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const p_r3 = i0.ɵɵreference(1);
    i0.ɵɵclassProp("responsive", ctx_r3.responsive);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.directionLinks);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", p_r3.getCurrent(), " / ", p_r3.getLastPage(), " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", p_r3.pages)("ngForTrackBy", ctx_r3.trackByIndex);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.directionLinks);
  }
}
class PaginationService {
  constructor() {
    this.change = new EventEmitter();
    this.instances = {};
    this.DEFAULT_ID = 'DEFAULT_PAGINATION_ID';
  }
  defaultId() {
    return this.DEFAULT_ID;
  }
  /**
   * Register a PaginationInstance with this service. Returns a
   * boolean value signifying whether the instance is new or
   * updated (true = new or updated, false = unchanged).
   */
  register(instance) {
    if (instance.id == null) {
      instance.id = this.DEFAULT_ID;
    }
    if (!this.instances[instance.id]) {
      this.instances[instance.id] = instance;
      return true;
    } else {
      return this.updateInstance(instance);
    }
  }
  /**
   * Check each property of the instance and update any that have changed. Return
   * true if any changes were made, else return false.
   */
  updateInstance(instance) {
    let changed = false;
    for (let prop in this.instances[instance.id]) {
      if (instance[prop] !== this.instances[instance.id][prop]) {
        this.instances[instance.id][prop] = instance[prop];
        changed = true;
      }
    }
    return changed;
  }
  /**
   * Returns the current page number.
   */
  getCurrentPage(id) {
    if (this.instances[id]) {
      return this.instances[id].currentPage;
    }
    return 1;
  }
  /**
   * Sets the current page number.
   */
  setCurrentPage(id, page) {
    if (this.instances[id]) {
      let instance = this.instances[id];
      let maxPage = Math.ceil(instance.totalItems / instance.itemsPerPage);
      if (page <= maxPage && 1 <= page) {
        this.instances[id].currentPage = page;
        this.change.emit(id);
      }
    }
  }
  /**
   * Sets the value of instance.totalItems
   */
  setTotalItems(id, totalItems) {
    if (this.instances[id] && 0 <= totalItems) {
      this.instances[id].totalItems = totalItems;
      this.change.emit(id);
    }
  }
  /**
   * Sets the value of instance.itemsPerPage.
   */
  setItemsPerPage(id, itemsPerPage) {
    if (this.instances[id]) {
      this.instances[id].itemsPerPage = itemsPerPage;
      this.change.emit(id);
    }
  }
  /**
   * Returns a clone of the pagination instance object matching the id. If no
   * id specified, returns the instance corresponding to the default id.
   */
  getInstance(id = this.DEFAULT_ID) {
    if (this.instances[id]) {
      return this.clone(this.instances[id]);
    }
    return {};
  }
  /**
   * Perform a shallow clone of an object.
   */
  clone(obj) {
    var target = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        target[i] = obj[i];
      }
    }
    return target;
  }
}
const LARGE_NUMBER = Number.MAX_SAFE_INTEGER;
let PaginatePipe = /*#__PURE__*/(() => {
  class PaginatePipe {
    constructor(service) {
      this.service = service;
      // store the values from the last time the pipe was invoked
      this.state = {};
    }
    transform(collection, args) {
      // When an observable is passed through the AsyncPipe, it will output
      // `null` until the subscription resolves. In this case, we want to
      // use the cached data from the `state` object to prevent the NgFor
      // from flashing empty until the real values arrive.
      if (!(collection instanceof Array)) {
        let _id = args.id || this.service.defaultId();
        if (this.state[_id]) {
          return this.state[_id].slice;
        } else {
          return collection;
        }
      }
      let serverSideMode = args.totalItems && args.totalItems !== collection.length;
      let instance = this.createInstance(collection, args);
      let id = instance.id;
      let start, end;
      let perPage = instance.itemsPerPage;
      let emitChange = this.service.register(instance);
      if (!serverSideMode && collection instanceof Array) {
        perPage = +perPage || LARGE_NUMBER;
        start = (instance.currentPage - 1) * perPage;
        end = start + perPage;
        let isIdentical = this.stateIsIdentical(id, collection, start, end);
        if (isIdentical) {
          return this.state[id].slice;
        } else {
          let slice = collection.slice(start, end);
          this.saveState(id, collection, slice, start, end);
          this.service.change.emit(id);
          return slice;
        }
      } else {
        if (emitChange) {
          this.service.change.emit(id);
        }
        // save the state for server-side collection to avoid null
        // flash as new data loads.
        this.saveState(id, collection, collection, start, end);
        return collection;
      }
    }
    /**
     * Create an PaginationInstance object, using defaults for any optional properties not supplied.
     */
    createInstance(collection, config) {
      this.checkConfig(config);
      return {
        id: config.id != null ? config.id : this.service.defaultId(),
        itemsPerPage: +config.itemsPerPage || 0,
        currentPage: +config.currentPage || 1,
        totalItems: +config.totalItems || collection.length
      };
    }
    /**
     * Ensure the argument passed to the filter contains the required properties.
     */
    checkConfig(config) {
      const required = ['itemsPerPage', 'currentPage'];
      const missing = required.filter(prop => !(prop in config));
      if (0 < missing.length) {
        throw new Error(`PaginatePipe: Argument is missing the following required properties: ${missing.join(', ')}`);
      }
    }
    /**
     * To avoid returning a brand new array each time the pipe is run, we store the state of the sliced
     * array for a given id. This means that the next time the pipe is run on this collection & id, we just
     * need to check that the collection, start and end points are all identical, and if so, return the
     * last sliced array.
     */
    saveState(id, collection, slice, start, end) {
      this.state[id] = {
        collection,
        size: collection.length,
        slice,
        start,
        end
      };
    }
    /**
     * For a given id, returns true if the collection, size, start and end values are identical.
     */
    stateIsIdentical(id, collection, start, end) {
      let state = this.state[id];
      if (!state) {
        return false;
      }
      let isMetaDataIdentical = state.size === collection.length && state.start === start && state.end === end;
      if (!isMetaDataIdentical) {
        return false;
      }
      return state.slice.every((element, index) => element === collection[start + index]);
    }
  }
  PaginatePipe.ɵfac = function PaginatePipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PaginatePipe)(i0.ɵɵdirectiveInject(PaginationService, 16));
  };
  PaginatePipe.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "paginate",
    type: PaginatePipe,
    pure: false,
    standalone: false
  });
  return PaginatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The default template and styles for the pagination links are borrowed directly
 * from Zurb Foundation 6: http://foundation.zurb.com/sites/docs/pagination.html
 */
const DEFAULT_TEMPLATE = `
    <pagination-template  #p="paginationApi"
                         [id]="id"
                         [maxSize]="maxSize"
                         (pageChange)="pageChange.emit($event)"
                         (pageBoundsCorrection)="pageBoundsCorrection.emit($event)">
    <nav role="navigation" [attr.aria-label]="screenReaderPaginationLabel">
    <ul class="ngx-pagination" 
        [class.responsive]="responsive"
        *ngIf="!(autoHide && p.pages.length <= 1)">

        <li class="pagination-previous" [class.disabled]="p.isFirstPage()" *ngIf="directionLinks"> 
            <a tabindex="0" *ngIf="1 < p.getCurrent()" (keyup.enter)="p.previous()" (click)="p.previous()">
                {{ previousLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
            </a>
            <span *ngIf="p.isFirstPage()" aria-disabled="true">
                {{ previousLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
            </span>
        </li> 

        <li class="small-screen">
            {{ p.getCurrent() }} / {{ p.getLastPage() }}
        </li>

        <li [class.current]="p.getCurrent() === page.value" 
            [class.ellipsis]="page.label === '...'"
            *ngFor="let page of p.pages; trackBy: trackByIndex">
            <a tabindex="0" (keyup.enter)="p.setCurrent(page.value)" (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
                <span class="show-for-sr">{{ screenReaderPageLabel }} </span>
                <span>{{ (page.label === '...') ? page.label : (page.label | number:'') }}</span>
            </a>
            <ng-container *ngIf="p.getCurrent() === page.value">
              <span aria-live="polite">
                <span class="show-for-sr">{{ screenReaderCurrentLabel }} </span>
                <span>{{ (page.label === '...') ? page.label : (page.label | number:'') }}</span> 
              </span>
            </ng-container>
        </li>

        <li class="pagination-next" [class.disabled]="p.isLastPage()" *ngIf="directionLinks">
            <a tabindex="0" *ngIf="!p.isLastPage()" (keyup.enter)="p.next()" (click)="p.next()">
                 {{ nextLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
            </a>
            <span *ngIf="p.isLastPage()" aria-disabled="true">
                 {{ nextLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
            </span>
        </li>

    </ul>
    </nav>
    </pagination-template>
    `;
const DEFAULT_STYLES = `
.ngx-pagination {
  margin-left: 0;
  margin-bottom: 1rem; }
  .ngx-pagination::before, .ngx-pagination::after {
    content: ' ';
    display: table; }
  .ngx-pagination::after {
    clear: both; }
  .ngx-pagination li {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    margin-right: 0.0625rem;
    border-radius: 0; }
  .ngx-pagination li {
    display: inline-block; }
  .ngx-pagination a,
  .ngx-pagination button {
    color: #0a0a0a; 
    display: block;
    padding: 0.1875rem 0.625rem;
    border-radius: 0; }
    .ngx-pagination a:hover,
    .ngx-pagination button:hover {
      background: #e6e6e6; }
  .ngx-pagination .current {
    padding: 0.1875rem 0.625rem;
    background: #2199e8;
    color: #fefefe;
    cursor: default; }
  .ngx-pagination .disabled {
    padding: 0.1875rem 0.625rem;
    color: #cacaca;
    cursor: default; } 
    .ngx-pagination .disabled:hover {
      background: transparent; }
  .ngx-pagination a, .ngx-pagination button {
    cursor: pointer; }

.ngx-pagination .pagination-previous a::before,
.ngx-pagination .pagination-previous.disabled::before { 
  content: '«';
  display: inline-block;
  margin-right: 0.5rem; }

.ngx-pagination .pagination-next a::after,
.ngx-pagination .pagination-next.disabled::after {
  content: '»';
  display: inline-block;
  margin-left: 0.5rem; }

.ngx-pagination .show-for-sr {
  position: absolute !important;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0); }
.ngx-pagination .small-screen {
  display: none; }
@media screen and (max-width: 601px) {
  .ngx-pagination.responsive .small-screen {
    display: inline-block; } 
  .ngx-pagination.responsive li:not(.small-screen):not(.pagination-previous):not(.pagination-next) {
    display: none; }
}
  `;

/**
 * This directive is what powers all pagination controls components, including the default one.
 * It exposes an API which is hooked up to the PaginationService to keep the PaginatePipe in sync
 * with the pagination controls.
 */
let PaginationControlsDirective = /*#__PURE__*/(() => {
  class PaginationControlsDirective {
    constructor(service, changeDetectorRef) {
      this.service = service;
      this.changeDetectorRef = changeDetectorRef;
      this.maxSize = 7;
      this.pageChange = new EventEmitter();
      this.pageBoundsCorrection = new EventEmitter();
      this.pages = [];
      this.changeSub = this.service.change.subscribe(id => {
        if (this.id === id) {
          this.updatePageLinks();
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
        }
      });
    }
    ngOnInit() {
      if (this.id === undefined) {
        this.id = this.service.defaultId();
      }
      this.updatePageLinks();
    }
    ngOnChanges(changes) {
      this.updatePageLinks();
    }
    ngOnDestroy() {
      this.changeSub.unsubscribe();
    }
    /**
     * Go to the previous page
     */
    previous() {
      this.checkValidId();
      this.setCurrent(this.getCurrent() - 1);
    }
    /**
     * Go to the next page
     */
    next() {
      this.checkValidId();
      this.setCurrent(this.getCurrent() + 1);
    }
    /**
     * Returns true if current page is first page
     */
    isFirstPage() {
      return this.getCurrent() === 1;
    }
    /**
     * Returns true if current page is last page
     */
    isLastPage() {
      return this.getLastPage() === this.getCurrent();
    }
    /**
     * Set the current page number.
     */
    setCurrent(page) {
      this.pageChange.emit(page);
    }
    /**
     * Get the current page number.
     */
    getCurrent() {
      return this.service.getCurrentPage(this.id);
    }
    /**
     * Returns the last page number
     */
    getLastPage() {
      let inst = this.service.getInstance(this.id);
      if (inst.totalItems < 1) {
        // when there are 0 or fewer (an error case) items, there are no "pages" as such,
        // but it makes sense to consider a single, empty page as the last page.
        return 1;
      }
      return Math.ceil(inst.totalItems / inst.itemsPerPage);
    }
    getTotalItems() {
      return this.service.getInstance(this.id).totalItems;
    }
    checkValidId() {
      if (this.service.getInstance(this.id).id == null) {
        console.warn(`PaginationControlsDirective: the specified id "${this.id}" does not match any registered PaginationInstance`);
      }
    }
    /**
     * Updates the page links and checks that the current page is valid. Should run whenever the
     * PaginationService.change stream emits a value matching the current ID, or when any of the
     * input values changes.
     */
    updatePageLinks() {
      let inst = this.service.getInstance(this.id);
      const correctedCurrentPage = this.outOfBoundCorrection(inst);
      if (correctedCurrentPage !== inst.currentPage) {
        setTimeout(() => {
          this.pageBoundsCorrection.emit(correctedCurrentPage);
          this.pages = this.createPageArray(inst.currentPage, inst.itemsPerPage, inst.totalItems, this.maxSize);
        });
      } else {
        this.pages = this.createPageArray(inst.currentPage, inst.itemsPerPage, inst.totalItems, this.maxSize);
      }
    }
    /**
     * Checks that the instance.currentPage property is within bounds for the current page range.
     * If not, return a correct value for currentPage, or the current value if OK.
     */
    outOfBoundCorrection(instance) {
      const totalPages = Math.ceil(instance.totalItems / instance.itemsPerPage);
      if (totalPages < instance.currentPage && 0 < totalPages) {
        return totalPages;
      } else if (instance.currentPage < 1) {
        return 1;
      }
      return instance.currentPage;
    }
    /**
     * Returns an array of Page objects to use in the pagination controls.
     */
    createPageArray(currentPage, itemsPerPage, totalItems, paginationRange) {
      // paginationRange could be a string if passed from attribute, so cast to number.
      paginationRange = +paginationRange;
      let pages = [];
      // Return 1 as default page number
      // Make sense to show 1 instead of empty when there are no items
      const totalPages = Math.max(Math.ceil(totalItems / itemsPerPage), 1);
      const halfWay = Math.ceil(paginationRange / 2);
      const isStart = currentPage <= halfWay;
      const isEnd = totalPages - halfWay < currentPage;
      const isMiddle = !isStart && !isEnd;
      let ellipsesNeeded = paginationRange < totalPages;
      let i = 1;
      while (i <= totalPages && i <= paginationRange) {
        let label;
        let pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages);
        let openingEllipsesNeeded = i === 2 && (isMiddle || isEnd);
        let closingEllipsesNeeded = i === paginationRange - 1 && (isMiddle || isStart);
        if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
          label = '...';
        } else {
          label = pageNumber;
        }
        pages.push({
          label: label,
          value: pageNumber
        });
        i++;
      }
      return pages;
    }
    /**
     * Given the position in the sequence of pagination links [i],
     * figure out what page number corresponds to that position.
     */
    calculatePageNumber(i, currentPage, paginationRange, totalPages) {
      let halfWay = Math.ceil(paginationRange / 2);
      if (i === paginationRange) {
        return totalPages;
      } else if (i === 1) {
        return i;
      } else if (paginationRange < totalPages) {
        if (totalPages - halfWay < currentPage) {
          return totalPages - paginationRange + i;
        } else if (halfWay < currentPage) {
          return currentPage - halfWay + i;
        } else {
          return i;
        }
      } else {
        return i;
      }
    }
  }
  PaginationControlsDirective.ɵfac = function PaginationControlsDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PaginationControlsDirective)(i0.ɵɵdirectiveInject(PaginationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
  };
  PaginationControlsDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: PaginationControlsDirective,
    selectors: [["pagination-template"], ["", "pagination-template", ""]],
    inputs: {
      id: "id",
      maxSize: "maxSize"
    },
    outputs: {
      pageChange: "pageChange",
      pageBoundsCorrection: "pageBoundsCorrection"
    },
    exportAs: ["paginationApi"],
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature]
  });
  return PaginationControlsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function coerceToBoolean(input) {
  return !!input && input !== 'false';
}
/**
 * The default pagination controls component. Actually just a default implementation of a custom template.
 */
let PaginationControlsComponent = /*#__PURE__*/(() => {
  class PaginationControlsComponent {
    constructor() {
      this.maxSize = 7;
      this.previousLabel = 'Previous';
      this.nextLabel = 'Next';
      this.screenReaderPaginationLabel = 'Pagination';
      this.screenReaderPageLabel = 'page';
      this.screenReaderCurrentLabel = `You're on page`;
      this.pageChange = new EventEmitter();
      this.pageBoundsCorrection = new EventEmitter();
      this._directionLinks = true;
      this._autoHide = false;
      this._responsive = false;
    }
    get directionLinks() {
      return this._directionLinks;
    }
    set directionLinks(value) {
      this._directionLinks = coerceToBoolean(value);
    }
    get autoHide() {
      return this._autoHide;
    }
    set autoHide(value) {
      this._autoHide = coerceToBoolean(value);
    }
    get responsive() {
      return this._responsive;
    }
    set responsive(value) {
      this._responsive = coerceToBoolean(value);
    }
    trackByIndex(index) {
      return index;
    }
  }
  PaginationControlsComponent.ɵfac = function PaginationControlsComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PaginationControlsComponent)();
  };
  PaginationControlsComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PaginationControlsComponent,
    selectors: [["pagination-controls"]],
    inputs: {
      id: "id",
      maxSize: "maxSize",
      directionLinks: "directionLinks",
      autoHide: "autoHide",
      responsive: "responsive",
      previousLabel: "previousLabel",
      nextLabel: "nextLabel",
      screenReaderPaginationLabel: "screenReaderPaginationLabel",
      screenReaderPageLabel: "screenReaderPageLabel",
      screenReaderCurrentLabel: "screenReaderCurrentLabel"
    },
    outputs: {
      pageChange: "pageChange",
      pageBoundsCorrection: "pageBoundsCorrection"
    },
    standalone: false,
    decls: 4,
    vars: 4,
    consts: [["p", "paginationApi"], [3, "pageChange", "pageBoundsCorrection", "id", "maxSize"], ["role", "navigation"], ["class", "ngx-pagination", 3, "responsive", 4, "ngIf"], [1, "ngx-pagination"], ["class", "pagination-previous", 3, "disabled", 4, "ngIf"], [1, "small-screen"], [3, "current", "ellipsis", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "pagination-next", 3, "disabled", 4, "ngIf"], [1, "pagination-previous"], ["tabindex", "0", 3, "keyup.enter", "click", 4, "ngIf"], ["aria-disabled", "true", 4, "ngIf"], ["tabindex", "0", 3, "keyup.enter", "click"], [1, "show-for-sr"], ["aria-disabled", "true"], [4, "ngIf"], ["aria-live", "polite"], [1, "pagination-next"]],
    template: function PaginationControlsComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "pagination-template", 1, 0);
        i0.ɵɵlistener("pageChange", function PaginationControlsComponent_Template_pagination_template_pageChange_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.pageChange.emit($event));
        })("pageBoundsCorrection", function PaginationControlsComponent_Template_pagination_template_pageBoundsCorrection_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.pageBoundsCorrection.emit($event));
        });
        i0.ɵɵelementStart(2, "nav", 2);
        i0.ɵɵtemplate(3, PaginationControlsComponent_ul_3_Template, 6, 8, "ul", 3);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        const p_r3 = i0.ɵɵreference(1);
        i0.ɵɵproperty("id", ctx.id)("maxSize", ctx.maxSize);
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-label", ctx.screenReaderPaginationLabel);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !(ctx.autoHide && p_r3.pages.length <= 1));
      }
    },
    dependencies: [PaginationControlsDirective, i2.NgIf, i2.NgForOf, i2.DecimalPipe],
    styles: [".ngx-pagination{margin-left:0;margin-bottom:1rem}.ngx-pagination:before,.ngx-pagination:after{content:\" \";display:table}.ngx-pagination:after{clear:both}.ngx-pagination li{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;margin-right:.0625rem;border-radius:0}.ngx-pagination li{display:inline-block}.ngx-pagination a,.ngx-pagination button{color:#0a0a0a;display:block;padding:.1875rem .625rem;border-radius:0}.ngx-pagination a:hover,.ngx-pagination button:hover{background:#e6e6e6}.ngx-pagination .current{padding:.1875rem .625rem;background:#2199e8;color:#fefefe;cursor:default}.ngx-pagination .disabled{padding:.1875rem .625rem;color:#cacaca;cursor:default}.ngx-pagination .disabled:hover{background:transparent}.ngx-pagination a,.ngx-pagination button{cursor:pointer}.ngx-pagination .pagination-previous a:before,.ngx-pagination .pagination-previous.disabled:before{content:\"\\ab\";display:inline-block;margin-right:.5rem}.ngx-pagination .pagination-next a:after,.ngx-pagination .pagination-next.disabled:after{content:\"\\bb\";display:inline-block;margin-left:.5rem}.ngx-pagination .show-for-sr{position:absolute!important;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0)}.ngx-pagination .small-screen{display:none}@media screen and (max-width: 601px){.ngx-pagination.responsive .small-screen{display:inline-block}.ngx-pagination.responsive li:not(.small-screen):not(.pagination-previous):not(.pagination-next){display:none}}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
  return PaginationControlsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxPaginationModule = /*#__PURE__*/(() => {
  class NgxPaginationModule {}
  NgxPaginationModule.ɵfac = function NgxPaginationModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxPaginationModule)();
  };
  NgxPaginationModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: NgxPaginationModule
  });
  NgxPaginationModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [PaginationService],
    imports: [[CommonModule]]
  });
  return NgxPaginationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-pagination
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxPaginationModule, PaginatePipe, PaginationControlsComponent, PaginationControlsDirective, PaginationService };
